import * as React from 'react';

import { cn } from '@/lib/utils/cn'; // Assuming this is a utility function for combining class names

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  bodyClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { className, bodyClassName, type = 'text', startIcon, endIcon, ...props },
    ref
  ) => {
    return (
      <div className={cn('relative flex items-center', bodyClassName)}>
        {startIcon && (
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            {startIcon}
          </div>
        )}
        <input
          ref={ref}
          type={type}
          className={cn(
            'h-10 w-full rounded-md border border-input bg-background py-2 px-4 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
            startIcon && 'pl-10', // Add padding for start icon
            endIcon && 'pr-10', // Add padding for end icon
            className
          )}
          {...props}
        />
        {endIcon && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {endIcon}
          </div>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export { Input };
